import createTtlCache from '../../utils/ttlCache';

const DEFAULT_TTL = 5 * 60 * 1000; // 5 minutes
const SHORT_TTL = 60 * 1000; // 1 minute for error cases

export const ownerReviewCache = createTtlCache({
  storageKey: 'ownerReviewCache_v1',
  ttl: DEFAULT_TTL,
  maxEntries: 1000,
});

export const reviewReportStatusCache = createTtlCache({
  storageKey: 'reviewReportStatusCache_v1',
  ttl: DEFAULT_TTL,
  maxEntries: 2000,
});

export const getOwnerReviewFromCache = (reservationId) => ownerReviewCache.get(reservationId);

export const setOwnerReviewCache = (reservationId, payload, customTtl) => {
  ownerReviewCache.set(reservationId, payload, customTtl ?? DEFAULT_TTL);
};

export const getReviewReportStatusFromCache = (cacheKey) => reviewReportStatusCache.get(cacheKey);

export const setReviewReportStatusCache = (cacheKey, payload, customTtl) => {
  reviewReportStatusCache.set(cacheKey, payload, customTtl ?? DEFAULT_TTL);
};

export const clearOwnerReviewCache = (reservationId) => ownerReviewCache.delete(reservationId);

export const clearAllOwnerReviewCache = () => ownerReviewCache.clear();

export const getShortCacheTtl = () => SHORT_TTL;
